'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002emath$002e$002dBig$002dInt from "./scala.math.-Big-Int.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$34(evaluator$35) {
  this.LC = null;
  this.LC = evaluator$35;
}
export { $c_Lsamples_Persons$package$$anon$34 as $c_Lsamples_Persons$package$$anon$34 };
$p = $c_Lsamples_Persons$package$$anon$34.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$34;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$34() {
}
export { $h_Lsamples_Persons$package$$anon$34 as $h_Lsamples_Persons$package$$anon$34 };
$h_Lsamples_Persons$package$$anon$34.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LC.h();
  return ((v instanceof $j_scala$002emath$002e$002dBig$002dInt.$c_s_math_BigInt) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$34 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$34, "samples.Persons$package$$anon$34", ({
  pQ: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$34 as $d_Lsamples_Persons$package$$anon$34 };
